import { updatedBySchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const deactivateTelemetryForVehiclePayload = z.object({
  vehicleUuid: z.uuid(),
  updatedBy: updatedBySchema,
});

export type DeactivateTelemetryForVehiclePayload = z.infer<
  typeof deactivateTelemetryForVehiclePayload
>;
